import { GiftCardData } from '../../types/apiTypes';
import { serverUtils } from '../serverUtils/serverUtils';

export const REDEEM_TOKEN_KEY = 'redeemToken';
export const REDEEM_CARD_KEY = 'redeemCard';

export const sessionStorageUtils = {
  getItem(key: string) {
    return !serverUtils.isServerSide()
      ? sessionStorage.getItem(key)
      : null;
  },
  setItem(key: string, value: string) {
    !serverUtils.isServerSide()
      && sessionStorage.setItem(key, value);
  },
  removeItem(key: string) {
    !serverUtils.isServerSide()
      && sessionStorage.removeItem(key);
  },
};

export const redeemUtils = {
  getRedeemToken() {
    return sessionStorageUtils.getItem(REDEEM_TOKEN_KEY);
  },
  setRedeemToken(token: string | null) {
    token
      ? sessionStorageUtils.setItem(REDEEM_TOKEN_KEY, token)
      : sessionStorageUtils.removeItem(REDEEM_TOKEN_KEY);
  },
  getRedeemCardData() {
    const data = sessionStorageUtils.getItem(REDEEM_CARD_KEY);
    return data
      ? JSON.parse(data)
      : null;
  },
  setRedeemCardData(data: GiftCardData | null) {
    data
      ? sessionStorageUtils.setItem(REDEEM_CARD_KEY, JSON.stringify(data))
      : sessionStorageUtils.removeItem(REDEEM_CARD_KEY);
  },
};
